<template>
	<div>
		<header>
		    <i></i>
		    <a class="back" @click="goBack">东方号</a>
		</header>
		<div class="main">
		    <h3>请通过注册手机号修改密码</h3>
		    <div class="row">
		        <input id="mobile" type="text" placeholder="登陆手机号" v-model="revisePwdParams.mobile"/>
		    </div>
		    <div class="row">
		        <input id="img-code" class="reset-input" type="text" placeholder="图片验证码" v-model="reviseCodeParams.authcode"/>
		        <img id="codeImg" :src="codeImg" alt="验证码" @click="changeCodeImg"/>
		    </div>
		    <div class="row">
		        <input id="code" type="text" placeholder="验证码" v-model="revisePwdParams.verifycode"/>
                <button type="button" id="codeBtn" @click="registCode" :class="btnDisabled ? 'disabled' : ''" v-if="!btnDisabled">发送验证码</button>
		        <button type="button" id="codeBtn" @click="registCode" :class="btnDisabled ? 'disabled' : ''" v-if="btnDisabled">重发（{{codeTimerNum}}s）</button>
		    </div>
		    <div class="row">
		        <input id="psw" type="password" placeholder="新密码" v-model="revisePwdParams.password"/>
		    </div>
		    <div class="row">
		        <input id="repsw" type="password" placeholder="确认新密码" v-model="resPassword"/>
		    </div>
		    <div class="tips">{{tips}}</div>
		    <div class="btn-submit" @click="EditPassword">确认修改</div>
		</div>
	</div>
</template>
<script>
    import {EditPassword, registCode, getuserinfo} from './../axios/api'
    // 线上环境
    const loginCodeImg = 'http://mp.eastday.com/mauthimage'
    // 测试环境
    // const loginCodeImg = 'http://tt.mp.eastday.com:8581/mauthimage'
	export default {
		name: 'RevisePwd',
		data (){
			return {
                revisePwdParams: {
                    mobile: '',
                    password: '',
                    verifycode: ''
                },
                reviseCodeParams: {
                    authcode: ''
                },
                codeImg: '',
                resPassword: '',
                judgeRule: [
                    {
                        ele: 'mobile',
                        func: function (val) {
                            let ifm = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(val);
                            return ifm;
                        },
                        error:'请输入正确的手机号'
                    },
                    {
                        ele: 'verifycode',
                        func: function (val) {
                            let ifm =/^\d{4,6}$/.test(val);
                            return ifm;
                        },
                        error:'请输入正确的验证码'
                    },
                    {
                        ele: 'password',
                        func: function (val) {
                            let reg = /^(?=.*[a-zA-Z])(?=.*\d)[~!@#$%^&*()_+`\-={}:";'<>?,.\/\w]{6,12}$/;
                            let ifm = reg.test(val);
                            return ifm;
                        },
                        error:'请输入正确格式的密码！'
                    }
                ],
                codeTimerNum: 120,
                btnDisabled: false,
                tips: '',
			}
		},
        mounted(){
            this.changeCodeImg();
            this.getRouteData();
		},
		methods:{
            getRouteData (){
                // 获取用户信息
                // if(this.$route.query.user.mediaHeadPic){
                //  this.userInfo = this.$route.query.user;
                // }
                let that = this;
                getuserinfo().then(result => {
                    if(result.stat != 1){
                        that.$router.push({path: '/Login'})
                        return;
                    }
                })
            },
            goBack (){
                this.$router.go(-1);
            },
            changeCodeImg (){
                this.codeImg = loginCodeImg+"?r="+Math.random();
            },
            checkAll (params){
                let that = this;
                let ifok = this.judgeRule.every(function(item) {
                    let ele = item.ele;
                    let func = item.func;
                    let ifm = func(params[ele]);
                    let error = item.error;

                    if (ifm) {
                        that.tips = '';
                    } else {
                        that.tips = error;
                    }
                    return ifm;
                });
                return ifok;
            },
            EditPassword (){
                let params = this.revisePwdParams;
                if(!this.checkAll(params)){
                    return false;
                }
                if(!(this.resPassword == params.password)){
                    this.tips = '2次密码输入不一致';
                    return false;
                }
                let that = this;
                EditPassword(params).then( result => {
                    if (result.stat == 1) {
                        that.$router.push({path: '/Login'})
                    }else {
                        that.tips = result.msg;
                    }
                })
            },
            registCode (){
                let params = this.reviseCodeParams;
                params.mobile = this.revisePwdParams.mobile;
                let item = this.judgeRule[0];

                if(!item.func(params.mobile)){
                    this.tips = item.error;
                    return false;
                }
                if(params.authcode == ''){
                    this.tips = '请输入图片验证码';
                    return false;
                }
                if(this.btnDisabled){
                    return;
                }
                let that = this;
                registCode(params).then( result => {
                    if (result.stat == 1) {
                        that.codeTimerNum = 120;
                        that.btnDisabled = true;
                        let timer = setInterval(function () {
                            that.codeTimerNum--;
                            if (that.codeTimerNum <= 0) {
                                that.btnDisabled = false;
                                clearInterval(timer);
                                return;
                            }
                        }, 1000);
                    } else {
                        alert("error");
                    }
                })
            },
		}
	}
</script>
<style scoped>
	@import './../common/css/database.css';
	header{
        width:100%;height:1rem;
    }
    header i{
        display: inline-block;width:0.2rem;height:0.34rem;background: url('./../assets/img/left-arr.png') no-repeat;background-size: cover;margin-left: 0.3rem;vertical-align: -0.05rem;
    }
    header .back{
        font-size: 0.36rem;color:#f84e4e;line-height: 1rem;display: inline-block;position: relative;left: -0.105rem;
    }
    .main{
        width:7.5rem;min-height:100%;background: #fff;position: relative;
    }
    .main h3{
        width:100%;font-size: 0.36rem;color:#666666;margin: 1.2rem auto 1rem;text-align: center;font-weight: bold;
    }
    .btn-submit,.row{
        display: block;width:5rem;height:0.9rem;line-height: 0.9rem;font-size: 0.36rem;text-align: center;color:#333333;margin:0.4rem auto 0;
    }
    .row input{
        border-radius: 0.9rem;border:1px solid #bababa;width:100%;height:100%;text-align: center;
    }
    input:focus{
        border:1px solid #f96d6d;
    }
    input::-webkit-input-placeholder {
		color: #999;
	}
    .tips{
        width:5rem;font-size: 0.24rem;color:#ff4153;text-align: center;margin: 10px auto 0;line-height: 0.5rem;
    }
    .btn-submit{
        background: #f84e4e;color:#fff; margin:0.5rem auto 0;border:0;border-radius: 0.9rem;
    }
    #code{
        float: left;width:3rem;background: #fff;border-bottom-right-radius: 0;border-top-right-radius: 0;border-right: 0;
    }
    #codeBtn{
        float: left;width:2rem;background: #fd979f;color:#fff;height:100%;border-bottom-right-radius: 0.9rem;border-top-right-radius: 0.9rem;font-size: 0.3rem;
    }

    /* 图片验证码 */
    #img-code{
        float: left;
        width: 3rem;
        background: #fff;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        border-right: 0;
    }
    #codeImg {
        width: 2rem;
        height: 100%;
        border-radius: 0 0.9rem 0.9rem 0;
        vertical-align: top;
    }
    /* 按钮禁用 */
    .disabled{background-color: #ddd !important;}
</style>


// WEBPACK FOOTER //
// src/pages/revisePwd.vue